import { ref, computed, Ref, ComputedRef, watch } from 'vue';
import { Product } from './useProductDetail';
import { getImageUrl as getImageUrlUtil } from '@/utils/imageUtils'; // DODATO

export function useProductGallery(product: Ref<Product | null>) {
  const currentImage: Ref<string | null> = ref(null);
  const lightboxOpen = ref(false);

  // Set initial image when product loads
  watch(
    () => product.value,
    (newProduct) => {
      if (newProduct?.pictures && newProduct.pictures.length > 0) {
        const mainPicture = newProduct.pictures.find((pic) => pic.isMain);
        currentImage.value = mainPicture
          ? mainPicture.path
          : newProduct.pictures[0].path;
      } else {
        currentImage.value = null;
      }
    }
  );

  // Computed property for current image index
  const currentImageIndex: ComputedRef<number> = computed(() => {
    if (!product.value || !currentImage.value) return 0;

    const index = product.value.pictures.findIndex(
      (pic) => pic.path === currentImage.value
    );
    return index >= 0 ? index : 0;
  });

  // AŽURIRANA FUNKCIJA - koristi imageUtils umesto apiUrl
  const getImageUrl = (imagePath: string): string => {
    return getImageUrlUtil(imagePath);
  };

  // Lightbox methods
  const openLightbox = () => {
    lightboxOpen.value = true;
    // Prevent scrolling when lightbox is open
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    lightboxOpen.value = false;
    // Restore scrolling when lightbox is closed
    document.body.style.overflow = 'auto';
  };

  // Navigation methods
  const navigateToPreviousImage = () => {
    if (!product.value || !product.value.pictures.length) return;

    const currentIndex = currentImageIndex.value;
    const newIndex =
      currentIndex <= 0
        ? product.value.pictures.length - 1 // Go to last image if at first
        : currentIndex - 1; // Otherwise go to previous

    currentImage.value = product.value.pictures[newIndex].path;
  };

  const navigateToNextImage = () => {
    if (!product.value || !product.value.pictures.length) return;

    const currentIndex = currentImageIndex.value;
    const newIndex =
      currentIndex >= product.value.pictures.length - 1
        ? 0 // Go back to first image if at last
        : currentIndex + 1; // Otherwise go to next

    currentImage.value = product.value.pictures[newIndex].path;
  };

  // Keyboard event handler
  const handleKeyDown = (event: KeyboardEvent) => {
    if (!lightboxOpen.value) return;

    switch (event.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        navigateToPreviousImage();
        break;
      case 'ArrowRight':
        navigateToNextImage();
        break;
    }
  };

  return {
    currentImage,
    currentImageIndex,
    lightboxOpen,
    getImageUrl,
    openLightbox,
    closeLightbox,
    navigateToPreviousImage,
    navigateToNextImage,
    handleKeyDown,
  };
}
